import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup,FormArray, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { UserDataService } from '../../features/user-data.service';

@Component({
  selector: 'app-company-recording',
  templateUrl: './company-recording.component.html',
  styleUrls: ['./company-recording.component.css']
})
export class CompanyRecordingComponent implements OnInit {


  visible=false;
  token:any;
  record:any;
  userWithToken:any;
  error:any;
  searchText:any;
  users:any;
  loggedUser:any;
  toggle=true;

  companyName="";
  companyAdress="";
  companyIdentityNo="";
  constructor(private userData:UserDataService, private auth:AuthService, private route:Router ){}
   aslan=true;



    ngOnInit() {


     this.token=this.auth.token;
      this.loggedUser=this.auth.userMail;

     }






  findCompany() {
    this.visible=!this.visible;
    this.userData.fetchCompany(this.token).subscribe(
     (res: any) => {
      if (!res) {
        this.record="Başvuru Sahibi bulunamadı";
        alert("Başvuru Sahibi bulunamadı")
      } else {

   //   console.log(res);
      this.userWithToken=res;
      this.users = Object.keys(res).map((key) =>
      { return res[key] });

      this.users.key = Object.keys(res).map((key) =>
      { return (key) });

     console.log(this.users);
      this.record=""
    }},err=>this.error=(err.statusText)
  );
  }
  removeCompany(i:number) {
    if(confirm(this.users[i][0].CompanyName+" Başvuru Sahibinin kaydı silinecektir. Onaylıyor musunuz?")){
   // console.log(this.users[i][0]);
   /* this.userData.deletionRecords([this.loggedUser,Date.now()],"Başvuru Sahibi kaydı silindi",this.users[i][0]).subscribe();*/
   this.userData.deletionRecords([this.loggedUser,Date.now()],'Başvuru Sahibi kaydı silindi', `Silinen Başvuru Sahibi: ${this.users[i][0].CompanyName} `).subscribe();
   // console.log(this.loggedUser);
    /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
    this.userData.removeCompany(this.users.key[i]);
    this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
    this.route.navigate(['masterData']));
  alert('Başvuru Sahibi kaydı silindi')}
    //this.redirectTo('masterData');
  }




  redirectTo(uri:string){
    this.route.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.route.navigate([uri]));
 }

      submit() {
      var record=[];
      this.toggle=false;
      this.companyName=this.companyName?.toLowerCase();
      this.companyAdress=this.companyAdress?.toLowerCase();
      this.companyIdentityNo=this.companyIdentityNo?.toLowerCase();

        record.push({recordingUser:this.loggedUser, date:Date.now()});
            this.userData.addCompany(
                            this.companyName,
                            this.companyAdress,
                            this.companyIdentityNo,
                            record
                            ).
                            subscribe(arr=>{console.log(arr);
                            alert("Başvuru Sahibi kaydedildi")},
                            err=>{
                            this.error=err.statusText;
                            console.log(this.error)});
                            this.users=[];
                            this.record="Başvuru Sahibi Kaydedildi";
  }
}
